import Compressor from "compressorjs";
import React, { useState } from "react";
import { toast } from "react-toastify";
import License from '../../Assets/images/dl.png'
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import Handler from '../../Helpers/Handler'
import {reloadWindow} from '../../Helpers/Utils'

const DL = ({ requestKey }) => {
    const [details, setDetails] = useState({})
    const [loading, setLoading] = useState(false)
    const storeFile = (file, name) => {
        if (name === 'dlFrontPage') {
            setDetails((prev) => ({ ...prev, dlFrontPage: file, dlFrontPageUrl: URL.createObjectURL(file) }))
        }
        if (name === 'dlBackPage') {
            setDetails((prev) => ({ ...prev, dlBackPage: file, dlBackPageUrl: URL.createObjectURL(file) }))
        }
    }
    const compressImage = (file, name) => {
        new Compressor(file, {
            quality: 0.6,
            maxWidth: 800,
            maxHeight: 600,
            success(result) {
                if (result.size > 4.5 * 1024 * 1024) {
                    toast.error('Compressed image size exceeds 4.5 MB.');
                } else {
                    storeFile(result, name)
                }
            },
            error(err) {
                toast.error(err.message);
            },
        });
    }
    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            if (e.target.files[0]?.size > 4.5 * 1024 * 1024) {
                compressImage(e.target.files[0], [e.target.name]);
            } else {
                storeFile(e.target.files[0], e.target.name)
            }
        }
    }
    const handleChange = (e) => {
        setDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const verifyLicense = async () => {
        if (!details?.dlFrontPage) {return toast.error('License Photo Required'); }
        if (!details?.dlBackPage) {return toast.error('License Back Photo Required');  }
        if (details?.dl === "" || !details?.dl || (details?.dl?.length < 15 || details?.dl?.length > 16)) {return toast.error('Invalid Driving License'); }
        if (!details?.dob) {return toast.error("DOB is required"); }
        setLoading(true)
        const data = new FormData()
        data?.append('dl', details?.dl)
        data?.append('dob', details?.dob)
        data?.append('dlFrontPage', details?.dlFrontPage)
        data?.append("dlBackPage", details?.dlBackPage)
        const response = await Handler({ method: 'PATCH', url: `/customer/dl/verify/${requestKey}`, data: data, formData: true })
        setLoading(false);
        if (response?.success) {
            toast.success(response?.message);
            setTimeout(() => {
                reloadWindow()
                setLoading(false);
            }, 2000);
        } else {
            toast.error(response?.message)
        }

    }
    return (
        <React.Fragment>
            <div className="row justify-content-center py-4">
                <div className="col-xs-12 col-md-5">
                    <div className="d-flex justify-content-center align-items-center proof-form mb-3" >
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label disabled={loading} htmlFor='dlFrontPage' className={`btn me-2 ${details?.dlStatus ? "d-none" : ''}`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {

                                details?.dlFrontPageUrl ?
                                    <div className="img-div">
                                        <img className="document" src={details?.dlFrontPageUrl} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload DL Front Image
                                    </div>

                            }
                        </div>
                        <input disabled={loading} id="dlFrontPage" accept="image/*" className="document d-none" type="file" name="dlFrontPage" onChange={handleFileChange} />
                    </div>
                </div>
                <div className="col-xs-12 col-md-5">
                    <div className="d-flex justify-content-center align-items-center proof-form mb-3" >
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label htmlFor='dlBackPage' disabled={loading} className={`btn me-2 ${details?.dlStatus ? "d-none" : ''}`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {
                                details?.dlBackPageUrl ?
                                    <div className="img-div">
                                        <img className="document" src={details?.dlBackPageUrl} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload DL Back Image
                                    </div>

                            }
                        </div>
                        <input disabled={loading} id="dlBackPage" accept="image/*" className="document d-none" type="file" name="dlBackPage" onChange={handleFileChange} />
                    </div>
                </div>
            </div>
            <div className="row justify-content-center align-items-center">
                <div className="col-xs-12 col-md-5">
                    <div className="text-center"><img className="aadhaar-img" src={License} alt="License" /></div>
                </div>
                <div className="col-xs-12 col-md-5">
                    <div className="mb-3">
                        <label className="form-label fw-medium">Driving License Number </label>
                        <div className="d-flex">
                            <input autoComplete="off" type='text' name="dl" className="form-control" placeholder=" Ex : 123456789121" value={details?.dl || ""} onChange={handleChange} disabled={loading} />

                        </div>
                        {/* {!loading ?
                            <button disabled={details?.dlStatus ? true : false} onClick={verifyLicense} className={`btn ${details?.dlStatus ? "verified-btn" : "verify-aadhaar-btn"} w-100 p-2 mt-3`}>{details?.dlStatus ? "Verified" : "Verify Driving License"}</button>
                            :
                            <>

                            </>
                        } */}
                    </div>
                    <div className="mb-3">
                        <div className="d-flex flex-column col-xs-12 col-md-6">
                            <label className="form-label fw-medium">DOB </label>
                            <DatePicker format={'DD-MM-YYYY'}
                                className="calender-theme"
                                inputClass="form-control"
                                placeholder="Ex : 29-12-2001"
                                value={details?.dob ? details?.dob : ""}
                                onChange={(date) => {
                                    setDetails((prev) => ({ ...prev, dob: moment(date?.toDate()).format("DD-MM-YYYY") }))
                                }}
                                disabled={loading} />
                        </div>
                    </div>
                    <div className="text-center mb-3">
                        <button className="btn btn-success" onClick={verifyLicense} disabled={loading}>{loading ? "Verifying..." : "Submit"}</button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default DL